import { CSSProgressiveBody03 } from "@caisy/league";
import styled from "styled-components";

export const SFileUploadEmptyDescription = styled.div`
  color: var(--text-04);
  ${CSSProgressiveBody03}
`;
